import { useMediaQuery } from "@mui/material";
import React from "react";
import { theme } from "@/theme";
import { Button } from "@/components/Button";
import { PageModule } from "@/components/PageModule";
import Sticky from "@/components/Sticky";

export interface TrialHeaderProps {
  link: string;
}

export default function TrialHeader({ link }: TrialHeaderProps) {
  const isMobile: boolean = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );

  return (
    <Sticky displayThreshold={300}>
      <div className="scroll-shadows bg-white text-white">
        <PageModule className="h-16 py-2 md:h-20">
          <div className="flex w-full items-center justify-between">
            {isMobile ? (
              <div>
                <p className="body text-sm font-semibold text-primary">
                  Limited Time Offer:
                </p>
                <p className="body text-sm text-primary">
                  FREE Dishwasher Detergent
                </p>
              </div>
            ) : (
              <h6 className="body font-semibold text-primary">
                Limited Time Offer: FREE Dishwasher Detergent
              </h6>
            )}
            <Button
              className="ml-2"
              size={isMobile ? "md" : "lg"}
              href={link}
              component="a"
            >
              GET STARTED
            </Button>
          </div>
        </PageModule>
      </div>
    </Sticky>
  );
}
